import React from 'react';
import type { FC, ReactNode } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

interface HomePageGuardProps {
  children?: ReactNode;
}

const HomePageGuard: FC<HomePageGuardProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Redirect to="/portal/clients/dashboard" />;
  }

  return (
    <>
      {children}
    </>
  );
};

HomePageGuard.propTypes = {
  children: PropTypes.node
};

export default HomePageGuard;
